import React from "react";
import PasswordForm from "taskpane/components/passwordForm";
import { Link, useLocation } from "react-router-dom";
import { RoutePath } from "taskpane/models/enums";
import "../styles/passwordPage.css";
import { Domain } from "taskpane/models/types";

interface ILocationState extends Domain {
  email: string;
}

const PasswordPage: React.FC = (): React.JSX.Element => {
  const locationState = useLocation<ILocationState>().state;
  const email = locationState?.email;
  const domain = locationState?.domain;

  return (
    <div className="passwordPage" data-testid="passwordPage">
      <Link
        to={{ pathname: RoutePath.loginPage, state: { email } }}
        className="passwordPage__iconArrowBack"
        data-testid="linkLogin"
      >
        <img width="16" height="16" src="assets/arrow-left.svg" alt="Назад" />
      </Link>
      <div className="passwordPage__formContainer">
        <PasswordForm email={email} domain={domain} />
      </div>
    </div>
  );
};

export default PasswordPage;
